import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AciklamaAndUserControlPopup = ({ open, handleClose, description, isUserControlPopUp }:any) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) {
      navigate(-1);
    }
  }, [open, navigate]);

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Açıklama</DialogTitle>
      <DialogContent>
        {description}
      </DialogContent>
      <DialogActions>
        {isUserControlPopUp ? (
          <>
            <Button variant='contained' onClick={handleBackClick} color="secondary">
              Geri Dön
            </Button>
            <Button variant='contained' onClick={handleLoginClick} color="primary">
              Giriş Yap
            </Button>
          </>
        ) : (
          <Button variant='contained' onClick={handleClose} color="primary">
            Tamam
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AciklamaAndUserControlPopup;
